module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-redes-sociais-facebook.1b8f538d.jpg";